import { InjectionToken } from '@angular/core';
import { ClosetDoorsCustomClosetConfigurationComponent } from '../pages/configurators-2d/closet-doors/custom/closet-configuration/closet-configuration.component';
import { ClosetDoorsCustomEnvironmentComponent } from '../pages/configurators-2d/closet-doors/custom/environment/environment.component';
import { ClosetDoorsCustomFinishesComponent } from '../pages/configurators-2d/closet-doors/custom/finishes/finishes.component';
import { ClosetDoorsCustomAccessoriesComponent } from '../pages/configurators-2d/closet-doors/custom/accessories/accessories.component';
import { ClosetDoorsCustomSummaryComponent } from '../pages/configurators-2d/closet-doors/custom/summary/summary.component';
import { ClosetDoorsCustomSuppliersComponent } from '../pages/configurators-2d/closet-doors/custom/suppliers/suppliers.component';
import { ClosetDoorsCustomService } from '../services/configurators-2d/applications/closet-doors-custom.service';

export const CD_CUSTOM_ENVIRONMENT = new InjectionToken(typeof ClosetDoorsCustomEnvironmentComponent);
export const CD_CUSTOM_CLOSET_CONFIGURATION = new InjectionToken(typeof ClosetDoorsCustomClosetConfigurationComponent);
export const CD_CUSTOM_SUPPLIERS = new InjectionToken(typeof ClosetDoorsCustomSuppliersComponent);
export const CD_CUSTOM_FINISHES = new InjectionToken(typeof ClosetDoorsCustomFinishesComponent);
export const CD_CUSTOM_ACCESSORIES = new InjectionToken(typeof ClosetDoorsCustomAccessoriesComponent);
export const CD_CUSTOM_SUMMARY = new InjectionToken(typeof ClosetDoorsCustomSummaryComponent);

export const CD_CUSTOM_SERVICE = new InjectionToken(typeof ClosetDoorsCustomService);

export const closetDoorsCustomProviders = [
  {
    provide: CD_CUSTOM_SERVICE,
    useClass: ClosetDoorsCustomService,
  },
  {
    provide: CD_CUSTOM_ENVIRONMENT,
    useClass: ClosetDoorsCustomEnvironmentComponent,
  },
  {
    provide: CD_CUSTOM_CLOSET_CONFIGURATION,
    useClass: ClosetDoorsCustomClosetConfigurationComponent,
  },
  {
    provide: CD_CUSTOM_SUPPLIERS,
    useClass: ClosetDoorsCustomSuppliersComponent,
  },
  {
    provide: CD_CUSTOM_FINISHES,
    useClass: ClosetDoorsCustomFinishesComponent,
  },
  {
    provide: CD_CUSTOM_ACCESSORIES,
    useClass: ClosetDoorsCustomAccessoriesComponent,
  },
  {
    provide: CD_CUSTOM_SUMMARY,
    useClass: ClosetDoorsCustomSummaryComponent,
  },
];
